/* eslint-disable react/jsx-one-expression-per-line */
import { BuildRounded } from '@mui/icons-material'
import classNames from 'classnames'
import { TAppealOffer } from 'feature/appeals/type'
import { formatPriceInRubles } from 'helpers/formatPrice'

import { AppealOffer } from '../AppealOffer/AppealOffer'
import { OfferItem } from '../AppealOffer/OfferItem/OfferItem'
import { DropDownBlock } from '../DropDownBlock/DropDownBlock'

import style from './AppealOffersList.module.scss'

type TOrderOffers = {
  offers: TAppealOffer[]
}

// список КП
export function AppealOffersList({ offers }: TOrderOffers) {
  const hasApprovedOrder = offers.some(order => order.status === 'APPROVED')
  const hasPaidOrder =
    offers[0]?.offer?.payments?.every(payment => payment.isPaid === true) ??
    false

  return (
    <div className={style.orderOffers}>
      {offers.map((offerItem, index) => (
        <DropDownBlock
          key={offerItem.id}
          title={`коммерческое Предложение ${index + 1}`}
          isChildren
          className={style.offerDropdown}
          isOpen={
            offerItem.status === 'APPROVED' ||
            (!hasApprovedOrder && index === 0)
          }
        >
          <div className={style.offer}>
            <OfferItem offer={offerItem} />
            {offerItem?.service?.map(serviceItem => (
              <div className={style.serviceBlock} key={serviceItem.name}>
                <BuildRounded color='primary' />
                <span className='default-text'>{serviceItem.name}</span>
                <span className={classNames('h4', style.offerPrice)}>
                  {formatPriceInRubles(serviceItem.price)}
                </span>
              </div>
            ))}

            {offerItem.offer && (
              <div className={style.offerPayment}>
                <AppealOffer
                  offerItem={offerItem}
                  hasPaidOrder={hasPaidOrder}
                  hasApprovedOrder={hasApprovedOrder}
                />
              </div>
            )}
          </div>
        </DropDownBlock>
      ))}
    </div>
  )
}
